import { createGroupMailTableQuery } from 'owa-group-mail-list-actions';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import { MailFolderTableQuery, TableQueryType } from 'owa-mail-list-store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { readingPaneStore } from 'owa-mail-reading-pane-store';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import { onListViewTypeOptionSaved } from 'owa-options-actions/lib/onListViewTypeOptionSaved';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { createLazyOrchestrator } from 'owa-bundling';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { ARCHIVE_FOLDERS_TREE_TYPE, SHARED_FOLDERS_TREE_TYPE } from 'owa-folders';

export default createLazyOrchestrator(
    onListViewTypeOptionSaved,
    'clone_onListViewTypeOptionSavedOrchestrator',
    async actionMessage => {
        const { newListViewType } = actionMessage;

        const currentTableQuery = getSelectedTableView().tableQuery as MailFolderTableQuery;
        const selectedFolder = getSelectedFolder();
        // SelectedFolder can be null in the case of Groups and Categories
        const selectedFolderTreeType = selectedFolder?.treeType;
        if (
            currentTableQuery.type === TableQueryType.Search ||
            selectedFolderTreeType === ARCHIVE_FOLDERS_TREE_TYPE ||
            selectedFolderTreeType === SHARED_FOLDERS_TREE_TYPE
        ) {
            // Do not reload the Archive mailbox, Shared folder or search table when switching the listViewType options
            return;
        }

        let newTableQuery;
        if (currentTableQuery.type === TableQueryType.Group) {
            newTableQuery = createGroupMailTableQuery(currentTableQuery.folderId, newListViewType);
        } else {
            newTableQuery = createMailFolderTableQuery(
                currentTableQuery.folderId,
                newListViewType,
                currentTableQuery.scenarioType,
                currentTableQuery.focusedViewFilter,
                currentTableQuery.viewFilter,
                currentTableQuery.categoryName,
                currentTableQuery.sortBy,
                currentTableQuery.inboxClassificationFilter
            );
        }

        loadTableViewFromTableQuery(newTableQuery);

        // Cleanup the reading pane state based on the old listViewType
        switch (newListViewType) {
            case ReactListViewType.Conversation:
                readingPaneStore.itemReadingPaneViewState = null;
                break;

            case ReactListViewType.Message:
                readingPaneStore.conversationReadingPaneViewState = null;
                break;
        }
    }
);

export { default as ReactListViewType } from 'owa-service/lib/contract/ReactListViewType';
